import { render, staticRenderFns } from "./gift-card-review.vue?vue&type=template&id=63bb1df1&"
import script from "./gift-card-review.vue?vue&type=script&lang=js&"
export * from "./gift-card-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports